import { parseTemplate } from 'url-template';
import { ErrorResponse } from '~/Api/User/ProductGroup/RoMaxPrice/ErrorResponse';
import { mapRoMaxPrice } from '~/Api/User/ProductGroup/RoMaxPrice/mapRoMaxPrice';
import { RoMaxPrice } from '~/Api/User/ProductGroup/RoMaxPrice/RoMaxPrice';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

export interface Result {
	roMaxPrice: RoMaxPrice;
}

export const findRoMaxPrice = async (client: ApiClient, userId: string, groupId: string): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/ro-max-price');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }));
		const response = await request.json();
		return { roMaxPrice: mapRoMaxPrice(response.roMaxPrice) };
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
